<div class="page-container">
    <div class="page-header">
        <div class="header-content">
            <h1 class="page-title">Consignee Management</h1>
            <p class="page-subtitle">Manage your consignees and their delivery locations</p>
        </div>
    </div>

    <div class="card" [class.loading]="isLoading">
        <!-- Loading Overlay -->
        <div class="loading-overlay" *ngIf="isLoading">
            <mat-spinner diameter="50"></mat-spinner>
            <p class="loading-text">Loading consignees...</p>
        </div>
        <div class="card-header">
            <div class="search-wrapper">
                <mat-icon class="search-icon">search</mat-icon>
                <input type="text" class="search-input" [(ngModel)]="searchText"
                    placeholder="Search by name, contact or address..." />
                <mat-icon *ngIf="searchText" class="clear-icon" (click)="searchText = ''">close</mat-icon>
            </div>

            <button type="button" class="btn-primary" (click)="addNewConsignee()">
                <mat-icon>person_add</mat-icon>
                <span>Add Consignee</span>
            </button>
        </div>

        <div class="table-container">
            <table class="data-table">
                <thead>
                    <tr>
                        <th>Name / Company</th>
                        <th>Contact Name</th>
                        <th>Contact Number</th>
                        <th>Address</th>
                        <th class="th-actions">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let data of filteredOrders" class="table-row">
                        <td>
                            <div class="consignee-info">
                                <div class="consignee-avatar">
                                    <mat-icon>person</mat-icon>
                                </div>
                                <span class="consignee-name">{{ data.name }}</span>
                            </div>
                        </td>
                        <td>
                            <span class="cell-text">{{ data.contactName || '—' }}</span>
                        </td>
                        <td>
                            <span class="cell-text cell-text-secondary">{{ data.primaryContact || '—' }}</span>
                        </td>
                        <td>
                            <a [href]="'https://www.google.com/maps?q=' + (data.locations?.[0]?.locationPin || '0,0')" target="_blank" class="address-link">
                                <mat-icon class="location-icon">location_on</mat-icon>
                                <span>{{ data.address || '—' }}</span>
                            </a>
                        </td>
                        <td class="actions-cell">
                            <button class="btn-icon-action" (click)="editConsignee(data, $event)" title="More options">
                                <mat-icon>more_vert</mat-icon>
                            </button>

                            <div *ngIf="selectedConsigneeId === data.id" class="dropdown-menu"
                                [style.top]="dropdownPosition.top"
                                [style.right]="dropdownPosition.right">
                                <button class="dropdown-item" (click)="onEdit(data)">
                                    <mat-icon class="dropdown-icon edit-icon">edit</mat-icon>
                                    <span>Edit Consignee</span>
                                </button>
                                <div class="dropdown-divider"></div>
                                <button class="dropdown-item dropdown-item-danger" (click)="onDelete(data)">
                                    <mat-icon class="dropdown-icon">delete</mat-icon>
                                    <span>Delete Consignee</span>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

            <!-- Empty State -->
            <div *ngIf="filteredOrders.length === 0" class="empty-state">
                <mat-icon class="empty-icon">person_search</mat-icon>
                <h3>No consignees found</h3>
                <p>Try adjusting your search or add a new consignee</p>
            </div>
        </div>

        <div class="card-footer" *ngIf="filteredOrders.length > 0">
            <div class="pagination-info">
                Showing <strong>{{ filteredOrders.length }}</strong> of <strong>{{ datas.length }}</strong> consignees
            </div>
            <div class="pagination">
                <button class="pagination-btn" [disabled]="currentPage === 1"
                    (click)="getConsigneeList(currentPage - 1)" title="Previous page">
                    <mat-icon>chevron_left</mat-icon>
                </button>

                <ng-container *ngFor="let page of pages">
                    <button class="pagination-btn pagination-number"
                        [ngClass]="{ 'active': page === currentPage }" (click)="getConsigneeList(page)">
                        {{ page }}
                    </button>
                </ng-container>

                <button class="pagination-btn" [disabled]="currentPage === totalPages"
                    (click)="getConsigneeList(currentPage + 1)" title="Next page">
                    <mat-icon>chevron_right</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>
